export class UserProfileDataViewModel{
    constructor( confirmEmail, confirmPassword, email, firstName, isDGContractor, 
        lastName, password, webId, mobilePhoneNumber, hiddenValue, userId ){
        this.confirmEmail = confirmEmail
        this.confirmPassword = confirmPassword
        this.email = email
        this.firstName = firstName
        this.isDGContractor = isDGContractor,
        this.lastName = lastName,
        this.password = password,
        this.webId = webId,
        this.mobilePhoneNumber = mobilePhoneNumber,
        this.hiddenValue = hiddenValue,
        this.userId=userId
    }
    assign( obj ) {
        obj && Object.assign( this, obj )
    }
}